import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api, errMsg } from "@/lib/api";
import { Switch } from "@/components/ui/switch";
import { CalendarClock } from "lucide-react";
import { toast } from "sonner";

export const useBookingsOpen = () =>
  useQuery({ queryKey: ["public-settings"], queryFn: () => api.get("/settings/public").then((r) => r.data.bookings_open) });

export function ComingSoon({ testid = "bookings-coming-soon" }) {
  return (
    <div className="mt-4 rounded-2xl border border-teal-200 bg-teal-50 p-4 text-center" data-testid={testid}>
      <CalendarClock className="mx-auto h-6 w-6 text-primary" />
      <p className="mt-1 text-base font-semibold text-teal-900">Bookings Coming Soon</p>
      <p className="mt-1 text-sm text-teal-800">FairStay isn't taking reservations yet. Browse homes now and check back soon.</p>
    </div>
  );
}

// Admin switch: bookings stay closed to the public until the owner launches real bookings.
export function BookingsSwitch() {
  const qc = useQueryClient();
  const { data: open } = useBookingsOpen();
  const flip = async (v) => {
    if (v && !window.confirm("Open bookings to the public? Only do this once payments, tax, licensing and legal checks are complete.")) return;
    try {
      await api.put("/admin/settings/bookings", { open: v });
      qc.invalidateQueries({ queryKey: ["public-settings"] });
      toast.success(v ? "Bookings are now open" : "Bookings are closed (Coming Soon)");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-2xl border bg-white p-4" data-testid="admin-bookings-switch">
      <div>
        <p className="font-semibold">Public bookings: <span className={open ? "text-emerald-700" : "text-amber-700"} data-testid="admin-bookings-status">{open ? "OPEN" : "Coming Soon (closed)"}</span></p>
        <p className="text-xs text-stone-500">While closed, guests see "Bookings Coming Soon". Admins can still run test bookings.</p>
      </div>
      <Switch checked={!!open} onCheckedChange={flip} data-testid="admin-bookings-toggle" />
    </div>
  );
}
